import { get, post, patch } from "../../config/api";

class OffersService {
	static async uploadOffersCsv(formData) {
		const url = `/v1/billing/offer/csv/upload`;
		const headers = { accept: "multipart/form-data" };
		return await post({ url, data: formData, headers });
	}

	static async createOffer(data) {
		return await post({ url: "/v3/billing/offers", data });
	}

	static async updateOffer(id, data) {
		return await patch({ url: `/v3/billing/offers/${id}`, data });
	}

	static async getOffers({ page = 1, restaurantId, signal } = {}) {
		const params = { page };
		if (restaurantId) {
			params.restaurantId = restaurantId;
		}
		return await get({ url: "/v3/billing/offers", params, signal });
	}

	static async searchOffers({ query, page = 1, restaurantId, signal } = {}) {
		const params = { q: query, page };
		if (restaurantId) {
			const rid = encodeURIComponent(restaurantId);
			return await get({
				url: `/v3/billing/restaurants/${rid}/offers/search`,
				params,
				signal,
			});
		}
		return await get({
			url: "/v3/billing/offers/search",
			params,
			signal,
		});
	}

	static async getOfferById(id) {
		return await get({ url: `/v3/billing/offers/${id}` });
	}

	static async getOfferGroups() {
		return await get({ url: "/v3/billing/offer/group" });
	}

	static async createOfferGroup(data) {
		return await post({ url: "/v3/billing/offer/group", data });
	}

	static async changeOfferStatus(id, status) {
		return await patch({ url: `/v3/billing/offers/${id}/status`, data: { status } });
	}

	static async searchMenus(query) {
		return await get({
			url: "/v3/dashboard/menu/search",
			params: { query },
		});
	}
}

export default OffersService;
